<div fxLayout="column" fxLayoutGap="16px">
    <div class="panel-loading" *ngIf="loadingDynamicReports">
        <mat-progress-spinner mode="indeterminate" diameter="54" strokeWidth="6">
        </mat-progress-spinner>

        <div class="panel-loading-text">
            <div class="title">Carregando relatórios dinâmicos</div>
            <div class="subtitle">Montando indicadores cadastrados</div>
        </div>
    </div>

    <app-dashboard-dynamic-reports
        [reports]="dynamicReports"
        [filterData]="filterData"
        [loadingReportCodes]="loadingReportCodes"
        [loadedReportCodes]="loadedReportCodes"
        [expandCommand]="expandCommand"
        [filtersEnabled]="filtersEnabled"
        (reportsVisible)="onReportsVisible($event)"
        (filtersChange)="onReportFiltersChange($event)"
        (chartTypeChange)="onReportChartTypeChange($event)">
    </app-dashboard-dynamic-reports>
</div>
